<div>
    @if (visivel()) {
    <section class="avaliacao-bloco mt-5" aria-labelledby="tituloAvaliacaoBloco">
        <div class="element-wrapper">
            <div class="mt-3">
                <div class="mt-4">
                    <div class="title-wrapper">
                        <h2 class="page-title" id="tituloAvaliacaoBloco">Sua voz é importante!</h2>
                        <span class="title-line"></span>
                    </div>
                    <p class="card-subtitle mb-0">
                        Avalie o atendimento e registre suas manifestações de forma transparente.
                    </p>
                </div>
            </div>
        </div>

        <div class="cards-acoes">
            <button type="button" class="card-acao" [disabled]="botaoDesabilitado()" (click)="abrirModal()">
                <div class="card-left">
                    <span class="icon-circle icon-blue">
                        <i-lucide name="smile"></i-lucide>
                    </span>
                    <span class="card-text">Avalie nosso atendimento</span>
                </div>

                <i class="fa-solid fa-arrow-right card-arrow"></i>
            </button>

            <a [routerLink]="[atalho().link]" class="card-acao">
                <div class="card-left">
                    <span class="icon-circle icon-orange">
                        <i-lucide name="message-circle"></i-lucide>
                    </span>
                    <span class="card-text">{{ atalho().texto }}</span>
                </div>

                <i class="fa-solid fa-arrow-right card-arrow"></i>
            </a>
        </div>
    </section>
    }

    @if (modalAberto()) {
    <div class="modal-backdrop fade show" (click)="fecharModal()"></div>

    <div class="modal fade show modal-aberto" id="modalAvaliacao" tabindex="-1" role="dialog" aria-modal="true"
        aria-labelledby="tituloAvaliacao">
        <div class="modal-dialog modal-dialog-centered modal-avaliacao">
            <div class="modal-content avaliacao-modal">

                <div class="d-flex justify-content-between modal-header avaliacao-header">
                    <div class="avaliacao-header-left">
                        <span class="avaliacao-header-emoji" aria-hidden="true"><i-lucide
                                name="smile"></i-lucide></span>
                        <h5 class="modal-title" id="tituloAvaliacao">Avaliação de Atendimento</h5>
                    </div>

                    <button type="button" class="avaliacao-close" aria-label="Fechar" (click)="fecharModal()">
                        <i-lucide name="x"></i-lucide>
                    </button>
                </div>

                <div class="modal-body avaliacao-body">
                    <p class="avaliacao-pergunta">
                        Como você avaliaria sua experiência com nosso portal<br />
                        hoje?
                    </p>

                    <div class="rating-row" role="radiogroup" aria-label="Avaliação de 0 a 5">
                        @for (item of ratings; track item.value) {
                        <button type="button" class="rate-btn" [class]="'rate-' + item.value"
                            [class.is-selected]="selectedRate() === item.value" role="radio"
                            [attr.aria-checked]="selectedRate() === item.value" [attr.title]="item.label"
                            [attr.aria-label]="item.label" (click)="selectRate(item.value)">
                            <span class="emoji" aria-hidden="true">{{ item.emoji }}</span>
                            <span class="rate-num">{{ item.value }}</span>
                        </button>
                        }
                    </div>

                    <div class="avaliacao-textarea-wrap">
                        <label class="visually-hidden" for="comentarioAvaliacao">Comentário adicional (opcional)</label>
                        <textarea id="comentarioAvaliacao" class="form-control avaliacao-textarea" rows="3"
                            placeholder="Gostaria de deixar algum comentário adicional?&#10;(Opcional)"
                            [value]="comentario()" (input)="aoDigitarComentario($event)"></textarea>
                    </div>

                    <button type="button" class="btn btn-enviar" [disabled]="!formularioValido() || botaoDesabilitado()"
                        (click)="enviarAvaliacao()">
                        <span><i-lucide name="send"></i-lucide> Enviar avaliação</span>
                    </button>
                </div>

            </div>
        </div>
    </div>
    }
</div>